import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import typography from 'styles/typography';

import { extendedTheme } from './extended-theme';

const typeKeys = Object.keys(typography).map((key) => key.replace('.', ''));

const customTwMerge = extendTailwindMerge<string, string>({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: Object.keys(extendedTheme.fontSize),
        },
        ...typeKeys,
      ],
      'box-shadow': [
        {
          shadow: Object.keys(extendedTheme.boxShadow),
        },
      ],
    },
  },
});
/**
 * A handy utility that makes constructing class names easier.
 * It also merges tailwind classes.
 */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

export function getInitials(name: string) {
  const split = name.split(' ').map((n) => n[0]);
  return `${split[0]}${split.length > 1 ? split.pop() : ''}`;
}
